import axios from 'axios';

const AUTH_PATHS = [
  '/validate-user',
  '/verify-otp',
  '/login',
  '/reset-password',
  '/forget-password',
  '/password-otp-verify',
  '/forget-reset-password',
];

function isAuthEndpoint(url = '') {
  return AUTH_PATHS.some((path) => url.includes(path));
}

const api = axios.create({
  // baseURL: 'http://localhost:8080',
  baseURL: 'https://s24xmlrswb.execute-api.ap-south-1.amazonaws.com/dev',
});

function logApiDebug(phase, configOrResponse, extra = {}) {
  const config = configOrResponse?.config ?? configOrResponse;
  const url = config?.url ?? '';
  if (!isAuthEndpoint(url)) return;

  const base = config?.baseURL ?? api.defaults.baseURL ?? '';
  const fullUrl = base && url ? `${base}${url}` : url;

  console.warn(`[API] auth ${phase}:`, {
    method: config?.method,
    url: fullUrl,
    ...extra,
  });
}

// Add request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    // Do not attach stale tokens to login/auth calls (can cause 401 + page reload)
    if (token && !isAuthEndpoint(config.url)) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    logApiDebug('request', config, { body: config.data });
    return config;
  },
  (error) => {
    console.warn('[API] auth request setup failed:', error);
    return Promise.reject(error);
  }
);

// Add response interceptor to handle 401 errors (hooks cannot run here)
api.interceptors.response.use(
  (response) => {
    logApiDebug('response', response, {
      status: response.status,
      data: response.data,
    });
    return response;
  },
  (error) => {
    const url = error.config?.url ?? '';
    const base = error.config?.baseURL ?? api.defaults.baseURL ?? '';
    const fullUrl = base && url ? `${base}${url}` : url;

    if (isAuthEndpoint(url)) {
      console.warn('[API] auth error:', {
        url: fullUrl,
        method: error.config?.method,
        status: error.response?.status,
        statusText: error.response?.statusText,
        data: error.response?.data,
        message: error.message,
      });
    }

    const onLoginPage =
      typeof window !== 'undefined' && window.location.pathname === '/login';

    if (
      error.response?.status === 401 &&
      !isAuthEndpoint(url) &&
      !onLoginPage
    ) {
      localStorage.removeItem('token');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default api;